module.exports = {
  'ja-jp': require('./ja-jp.json'),
};
